import MultivariateFunction from "./comp/EInstances/MultivariateFunction";
import { Application } from "./comp/Lambda/Constructors";
import { External } from "./comp/Lambda/Constructors";
import "./RefText";

/**
 * @param {RefText} ref
 * @return {StatefulExpr}
 * @memberof module:RefTextValue
 */
function RefTextValue(ref) {
  var fn = "require('RefText').makeRef";
  return new Application(
    MultivariateFunction(fn, 2, ["Object", "Object"], "Object"),
    External(ref, "Object"));
}

export default RefTextValue
